/**
 * /!\ This file is auto-generated.
 *
 * This is the entry point of your standalone application.
 *
 * There are multiple tags used by the editor to inject code automatically:
 *     - `wle:auto-imports:start` and `wle:auto-imports:end`: The list of import statements
 *     - `wle:auto-register:start` and `wle:auto-register:end`: The list of component to register
 *     - `wle:auto-constants:start` and `wle:auto-constants:end`: The project's constants,
 *        such as the project's name, whether it should use the physx runtime, etc...
 *     - `wle:auto-benchmark:start` and `wle:auto-benchmark:end`: Append the benchmarking code
 */

import { Cursor } from './components/custom-cursor';
import { CursorTarget } from '@wonderlandengine/components';
import { FixedFoveation } from '@wonderlandengine/components';
import { HandTracking } from '@wonderlandengine/components';
import { HowlerAudioListener } from '@wonderlandengine/components';
import { MouseLookComponent } from './components/mouse-look';
import { PlayerHeight } from '@wonderlandengine/components';
import { TeleportComponent } from '@wonderlandengine/components';
import { VrModeActiveSwitch } from '@wonderlandengine/components';
import { WasdControlsComponent } from '@wonderlandengine/components';
import { ActiveHand } from './components/active-hand';
import { Blink } from './components/blink.js';
import { BoardBlock } from './components/board-block.js';
import { BoardInteraction } from './components/board-interaction.js';
import { CursorReticle } from './components/cursor-reticle.js';
import { DoorInteraction } from './components/door-interaction.js';
import { ElevatorGate } from './components/elevator-gate.js';
import { Flashlight } from './components/flashlight.js';
import { Particles } from './components/particles.js';
import { Player } from './components/player.js';
import { Scene1FirstDoor } from './components/scene1-firstDoor.js';
import { StartElevator } from './components/start-elevator.js';
import { TextFade } from './components/text-fade.js';
import { WasdControlsFps } from './components/wasd-controls-fps.js';
import { DrawerInteraction } from './components/drawer-interaction.js';
import { IntroBegin } from './components/intro-begin';
import { LevelManagerSceneOpening } from './scene-opening/level-manager-scene-opening.js';
import { LevelOpeningOpenLink } from './scene-opening/level-opening-open-link.js';
import { LevelManagerScene2 } from './scene2/level-manager-scene2.js';
import { Seq1DoorPhoto } from './scene2/seq1-door-photo.js';
import { Scene2LdaDoor } from './scene-opening/scene2-lda-door.js';
import { TextBubbles } from './components/text-bubbles.js';
import { HowlerAudioSource } from '@wonderlandengine/components';
import { CrimeDoc } from './components/crime-doc.js';
import { HeadTest } from './head-test.js';
import { InspectNote } from './components/inspect-note.js';
import { InspectWorldObjectOffsets } from './components/inspect-world-object-offsets.js';
import { InspectWorldObject } from './components/inspect-world-object.js';
import { InspectWorld } from './components/inspect-world.js';
import { Inventory } from './components/inventory.js';
import { InvestigationBoard } from './components/investigation-board.js';
import { Menu } from './components/menu.js';
import { MurderImage } from './components/murder-image.js';
import { Newspaper } from './components/newspaper.js';
import { GetSetRotation } from './rot-test.js';
import { SnapRotate } from './components/snap-rotate.js';
import { Locomotion } from './components/locomotion.js';
import { loadRuntime } from '@wonderlandengine/api';
import { GameManagerInstance, SceneNames } from './managers/gamemanager.js';
import { ActionAudio } from './components/actions/action-audio.js';
import { ActionEnable } from './components/actions/action-enable';
import { TriggerCollision } from './components/trigger-collision.js';
import { ActiveCamera } from './components/active-camera.js';
import { Teleport } from './components/teleport.js';
import { ActivateCursorOnHand } from './components/activate-cursor-on-hand';
import { HeadDirectionTrigger } from './components/head-direction-trigger';
import { LaughingManSequence } from './components/laughing-man-sequence';
import { KillerAnimationController } from './components/killer-animation-controller';
import { SnowParticles } from './components/snow-particles';
import { ActionShower } from './components/actions/action-shower';
import { CursorBillboard } from './components/cursor-billboard';
import { ActionEnableFlashlight } from './components/actions/action-enable-flashlight';
import { CallToActionManager } from './managers/call-to-action-manager';
import { PrefetchScene } from './components/prefetch-scene';
import { ShowLoading } from './components/show-loading'
import { Vignette } from './components/vignette'
import { HeadBlock } from './components/head-block'
import { TouchLook } from './components/touch-look'
import { TouchMove } from './components/touch-move'
import { TouchUI } from './components/touch-ui'
import { MobileActiveSwitch } from './components/mobile-active-switch'
import { CrimeDocProgress } from './components/crime-doc-progress.js'


import * as API from '@wonderlandengine/api'; // Deprecated: Backward compatibility.

/* wle:auto-constants:start */
const Constants = {
    ProjectName: 'DeadSecretCircle_Scene0Intro',
    RuntimeBaseName: 'WonderlandRuntime',
    WebXRRequiredFeatures: ['local',],
    WebXROptionalFeatures: ['local','local-floor',],
};
const RuntimeOptions = {
    physx: true,
    loader: false,
    xrFramebufferScaleFactor: 1.2,
    xrOfferSession: {
        mode: 'auto',
        features: Constants.WebXRRequiredFeatures,
        optionalFeatures: Constants.WebXROptionalFeatures,
    },
    canvas: 'canvas',
};
/* wle:auto-constants:end */

/* On heyVR, google gtag is initialized for us. On itch.io and gitlab
 * we need to initialize it ourselves.
 * The following line will be adapted based on where we are deploying to. */
window.dataLayer = window.dataLayer || [];
window.gtag = window.gtag || function gtag() { dataLayer.push(arguments); };

const googleAnalyticsId = 'G-5Q16NYDMKV';
if (googleAnalyticsId) {
    const s = document.createElement('script');
    s.async = true;
    s.src = "https://www.googletagmanager.com/gtag/js?id=" + googleAnalyticsId;
    document.head.appendChild(s);

    gtag('js', new Date());
    gtag('config', googleAnalyticsId);
}

const engine = await loadRuntime(Constants.RuntimeBaseName, RuntimeOptions);
engine.erasePrototypeOnDestroy = true;

Object.assign(engine, API); // Deprecated: Backward compatibility.
window.WL = engine; // Deprecated: Backward compatibility.

engine.onSceneLoaded.once(() => {
    const el = document.getElementById('version');
    if (el) setTimeout(() => el.remove(), 2000);
});

/* WebXR setup. */

function requestSession(mode) {
    engine
        .requestXRSession(
            mode,
            Constants.WebXRRequiredFeatures,
            Constants.WebXROptionalFeatures
        )
        .catch((e) => console.error(e));
}

function setupButtonsXR() {
    /* Setup AR / VR buttons */
    const arButton = document.getElementById('ar-button');
    if (arButton) {
        arButton.dataset.supported = engine.arSupported ? 1 : 0;
        if (engine.arSupported) {
            arButton.addEventListener('click', () => requestSession('immersive-ar'));
        }
    }
    const vrButton = document.getElementById('vr-button');
    if (vrButton) {
        vrButton.dataset.supported = engine.vrSupported ? 1 : 0;
        if (engine.vrSupported) {
            vrButton.addEventListener('click', () => requestSession('immersive-vr'));
        }
    }
    const fsButton = document.getElementById('fullscreen-button');
    if (!engine.vrSupported && !engine.arSupported ||
        /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)) {

        fsButton.dataset.supported = '1';

        engine.canvas.requestFullscreen =
            engine.canvas.requestFullscreen
            || engine.canvas.mozRequestFullscreen
            || engine.canvas.msRequestFullscreen
            || engine.canvas.webkitRequestFullscreen;

        fsButton.addEventListener('click', () => document.documentElement.requestFullscreen());

        document.addEventListener("fullscreenchange", () => {
            if (document.fullscreenElement) {
                document.querySelector('.xr-button-container').style.display = 'none';
            } else {
                document.querySelector('.xr-button-container').style.display = 'flex';
            }
        });

    } else {
        fsButton.dataset.supported = '0';
    }
}

if (document.readyState === 'loading') {
    window.addEventListener('load', setupButtonsXR);
} else {
    setupButtonsXR();
}

engine.registerComponent(Cursor);
engine.registerComponent(CursorTarget);
//engine.registerComponent(FingerCursor);
engine.registerComponent(FixedFoveation);
engine.registerComponent(HandTracking);
engine.registerComponent(HowlerAudioListener);
engine.registerComponent(MouseLookComponent);
engine.registerComponent(PlayerHeight);
engine.registerComponent(TeleportComponent);
engine.registerComponent(VrModeActiveSwitch);
engine.registerComponent(Blink);
engine.registerComponent(DrawerInteraction);
engine.registerComponent(IntroBegin);
engine.registerComponent(WasdControlsComponent);
engine.registerComponent(BoardBlock);
engine.registerComponent(BoardInteraction);
engine.registerComponent(CursorReticle);
engine.registerComponent(DoorInteraction);
engine.registerComponent(ElevatorGate);
engine.registerComponent(Flashlight);
engine.registerComponent(Particles);
engine.registerComponent(Player);
engine.registerComponent(Scene1FirstDoor);
engine.registerComponent(StartElevator);
engine.registerComponent(TextFade);
engine.registerComponent(WasdControlsFps);
engine.registerComponent(LevelManagerSceneOpening);
engine.registerComponent(Scene2LdaDoor);
engine.registerComponent(TextBubbles);
engine.registerComponent(HowlerAudioSource);
engine.registerComponent(CrimeDoc);
engine.registerComponent(DoorInteraction);
engine.registerComponent(DrawerInteraction);
engine.registerComponent(HeadTest);
engine.registerComponent(InspectNote);
engine.registerComponent(InspectWorldObjectOffsets);
engine.registerComponent(InspectWorldObject);
engine.registerComponent(InspectWorld);
engine.registerComponent(Inventory);
engine.registerComponent(InvestigationBoard);
engine.registerComponent(Menu);
engine.registerComponent(MurderImage);
engine.registerComponent(Newspaper);
engine.registerComponent(GetSetRotation);
engine.registerComponent(SnapRotate);
engine.registerComponent(Locomotion);
engine.registerComponent(LevelManagerScene2);
engine.registerComponent(Seq1DoorPhoto);
engine.registerComponent(ActionAudio);
engine.registerComponent(TriggerCollision);
engine.registerComponent(ActiveCamera);
engine.registerComponent(Teleport);
engine.registerComponent(ActiveHand);
engine.registerComponent(ActivateCursorOnHand);
engine.registerComponent(HeadDirectionTrigger);
engine.registerComponent(LaughingManSequence);
engine.registerComponent(ActionEnable);
engine.registerComponent(KillerAnimationController);
engine.registerComponent(SnowParticles);
engine.registerComponent(ActionShower);
engine.registerComponent(CursorBillboard);
engine.registerComponent(ActionEnableFlashlight);
engine.registerComponent(CallToActionManager);
engine.registerComponent(PrefetchScene);
engine.registerComponent(ShowLoading);
engine.registerComponent(Vignette);
engine.registerComponent(HeadBlock);
engine.registerComponent(TouchLook);
engine.registerComponent(TouchMove);
engine.registerComponent(MobileActiveSwitch);
engine.registerComponent(TouchUI);
engine.registerComponent(CrimeDocProgress);
engine.registerComponent(LevelOpeningOpenLink);

GameManagerInstance.initialize(engine);

// Always load the first scene.
GameManagerInstance.loadScene(SceneNames.Scene0);

/* wle:auto-benchmark:start */
/* wle:auto-benchmark:end */
